import { PRIV } from "components/access-control/rbac/privileges";
import paths, { rootPaths } from "./paths";

export const allRoutes = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      active: true,
      icon: "chart-pie",
      to: rootPaths.root,
    },

    // project management
    {
      name: "Project Management",
      icon: "project-diagram",
      active: true,
      children: [
        {
          name: "Dashboard",
          icon: "tachometer-alt",
          to: paths.pmDashboard,
          active: true,
        },
        {
          name: "Projects",
          icon: "project-diagram",
          to: paths.projects,
          active: true,
        },
        {
          name: "Tags",
          icon: "tags",
          to: paths.Tags,
          active: true,
        },
        {
          name: "Testable Apps",
          icon: "bug",
          to: paths.qaTestRuns,
          active: true,
          privilege: PRIV.VIEW_APPVERSIONS,
        },
      ],
    },
    // olitask routes
    {
      name: "Olitask App",
      icon: ["fab", "app-store"],
      active: true,
      children: [
        {
          name: "Users",
          icon: "user",
          active: true,
          privilege: PRIV.VIEW_USERS,
          children: [
            {
              name: "Customers",
              to: paths.customers,
              exact: true,
              componentProps: { staff: false },
            },
            {
              name: "Staff",
              to: paths.staff,
              exact: true,
              componentProps: { staff: true },
            },
            // {
            //   name: "Helper Profiles",
            //   to: paths.helperProfiles,
            //   exact: true,
            // },
            {
              name: "Helper Requests",
              to: paths.helperRequests,
              exact: true,
              componentProps: { staff: true },
            },

            {
              name: "User Affiliations",
              to: paths.userAffiliations,
              exact: true,
              componentProps: { staff: false },
            },
            {
              name: "User Deletion Requests",
              to: paths.userDeletionRequests,
              exact: true,
            },
            {
              name: "Guest Sessions",
              to: paths.guestSessions,
              exact: true,
              privilege: "VIEW_USERS",
            },
            {
              name: "Feedbacks",
              to: paths.feedBacks,
              active: true,
              privilege: PRIV.VIEW_FEEDBACKS,
            },
            {
              name: "Help & Support",
              to: paths.helpRequests,
              active: true,
              privilege: PRIV.VIEW_HELP_REQUESTS,
            },
          ],
        },

        {
          name: "Tasks",
          icon: "table",
          active: true,
          privilege: "VIEW_TASKS",
          children: [
            {
              name: "Categories",
              to: paths.taskCategories,
              active: true,
            },
            {
              name: "All Tasks",
              to: paths.tasks,
              active: false,
              privilege: "VIEW_TASKS",
            },
            {
              name: "Cancellation Rules",
              // icon: "ban",
              active: true,
              privilege: "VIEW_FEEDBACKS",
              children: [
                {
                  name: "Active Rules",
                  to: paths.cancellationPolicyActive,
                  active: true,
                },
                {
                  name: "History",
                  to: paths.cancellationPolicyHistory,
                  active: true,
                },
              ],
            },
          ],
        },

        {
          name: "Donations",
          icon: "box",
          active: true,
          privilege: "VIEW_DONATIONS",
          children: [
            {
              name: "Donations",
              to: paths.donationsList,
              active: true,
            },
            {
              name: "Guest Donations",
              to: paths.guestDonations,
              active: false,
            },
            {
              name: "Donation purposes",
              to: paths.donationsPurposes,
              active: false,
              privilege: "VIEW_DONATION_PURPOSES",
            },
            {
              name: "Credit Applications",
              to: paths.creditApplications,
              active: false,
              privilege: "VIEW_APPLICATIONS",
            },
            {
              name: "Issued Credits",
              to: paths.donationsCredit,
              active: false,
              privilege: "VIEW_CREDITS",
            },
          ],
        },

        {
          name: "App Versions",
          icon: "code-branch",
          to: paths.appVersions,
          active: true,
          privilege: PRIV.VIEW_APPVERSIONS,
        },
        {
          name: "QR Code Generator",
          icon: "qrcode",
          to: paths.QRCodeGenerator,
          active: false,
          privilege: "VIEW_TASKS",
        },
      ],
    },

   
    // financials
    {
      name: "Financials",
      icon: "wallet",
      active: true,
      children: [
        {
          name: "Charge Configs",
          icon: "money-bill",
          to: paths.paymentCharges,
          active: true,
          privilege: PRIV.VIEW_CHARGES,
        },
        {
          name: "Payments",
          icon: "credit-card",
          active: true,
          privilege: PRIV.VIEW_PAYOUTS,
          children: [
            {
              name: "Transactions",
              to: paths.paymentTransactions,
              active: true,
              privilege: PRIV.VIEW_PAYOUTS,
            },
          ],
        },
        {
          name: "Payouts",
          icon: "money-check",
          active: true,
          privilege: PRIV.VIEW_PAYOUTS,
          children: [
            {
              name: "Transactions",
              to: paths.payouts,
              active: true,
              privilege: PRIV.VIEW_PAYOUTS,
            },
            {
              name: "Charges",
              to: paths.payoutCharges,
              active: true,
              privilege: PRIV.VIEW_PAYOUTS,
            },
            {
              name: "External Accounts",
              to: paths.externalAccounts,
              active: true,
              privilege: PRIV.VIEW_PAYOUTS,
            },
          ],
        },
      ],
    },

    // communications
    {
      name: "Communications",
      icon: "envelope-open-text",
      active: true,
      children: [
        {
          name: "Message Templates",
          icon: "envelope-open-text",
          to: paths.messageTemplates,
          active: true,
          privilege: PRIV.VIEW_TEMPLATES,
        },
        {
          name: "Email",
          icon: "envelope-open",
          active: true,
          privilege: PRIV.VIEW_TEMPLATES,
          children: [
            {
              name: "Sent emails",
              to: paths.emailSent,
              active: true,
              privilege: PRIV.VIEW_TEMPLATES,
            },
            {
              name: "Compose",
              to: paths.emailCompose,
              active: true,
              privilege: "VIEW_TEMPLATES",
            },
          ],
        },
        {
          name: "Inhouse Emails",
          icon: "envelope",
          active: true,
          privilege: "VIEW_TEMPLATES",
          children: [
            {
              name: "Compose",
              to: paths.emailInhouseCompose,
              active: true,
              privilege: "VIEW_TEMPLATES",
            },
            {
              name: "Incoming emails",
              to: paths.emailIncoming,
              active: true,
              privilege: "VIEW_TEMPLATES",
            },
            {
              name: "Outgoing emails",
              to: paths.emailOutgoing,
              active: true,
              privilege: "VIEW_TEMPLATES",
            },
            {
              name: "Email accounts",
              to: paths.emailAccounts,
              active: true,
              privilege: "VIEW_TEMPLATES",
            },
          ],
        },
        {
          name: "Notification Topics",
          icon: "bell",
          to: paths.notificationTopics,
          active: true,
          privilege: PRIV.VIEW_NOTIFICATION_TOPICS,
        },
      ],
    },
     // profile
    {
      name: "Business Management",
      icon: "id-card",
      active: true,
      privilege: PRIV.UPDATE_PROFILE,
      children: [
        {
          name: "Entities",
          icon: "building",
          to: paths.businessEntities,
          active: true,
          privilege: PRIV.UPDATE_PROFILE,
        },
        {
          name: "Service Offerings",
          icon: "box",
          to: paths.serviceOfferings,
          active: true,
          privilege: PRIV.UPDATE_PROFILE,
        },
      ],
    },

    // air travel operations
    {
      name: "Airline Travel Ops",
      icon: "plane-departure",
      active: true,
      children: [
        {
          name: "TravoTasks",
          icon: "tasks",
          active: true,
          children: [
            {
              name: "Categories",
              to: paths.travelCategories,
              active: true,
            },
            {
              name: "Meeting Points",
              to: paths.meetingPoints,
              active: true,
            },
          ],
        },
        {
          name: "Airports",
          icon: "plane-arrival",
          to: paths.airports,
          active: true,
        },
      ],
    },

    // access control
    {
      name: "Access Control",
      icon: "user-shield",
      active: true,
      children: [
        {
          name: "Manage Apps",
          icon: ["fab", "adn"],
          to: paths.manageApps,
          active: true,
          privilege: PRIV.MANAGE_APPLICATIONS,
        },
        {
          name: "Roles",
          icon: "user-shield",
          to: paths.roles,
          active: true,
          privilege: PRIV.VIEW_ROLES,
        },

        {
          name: "Privileges",
          icon: "key",
          to: paths.privileges,
          active: true,
          privilege: PRIV.VIEW_PRIVILEGES,
        },
        {
          name: "Assign Permissions",
          icon: "link",
          to: paths.assignRole,
          active: true,
          privileges: [
            PRIV.ASSIGN_ROLES,
            PRIV.VIEW_ROLES,
            PRIV.VIEW_PRIVILEGES,
          ],
        },
        {
          name: "Gateway Routes",
          icon: "route",
          to: paths.routeRules,
          active: true,
          privilege: PRIV.MANAGE_APIS,
        },
        {
          name: "API Keys",
          icon: "layer-group",
          to: paths.apiKeys,
          active: true,
          privilege: PRIV.VIEW_APIKEYS,
        },
        {
          name: "Client IDs",
          icon: "poll",
          to: paths.clientIds,
          active: true,
          privilege: PRIV.VIEW_CLIENTIDS,
        },
        {
          name: "Rate Limit Events",
          icon: "hashtag",
          to: paths.rateLimitEvents,
          active: true,
          privilege: PRIV.VIEW_RATE_LIMITS,
        },
        {
          name: "Location Restriction",
          icon: "map-marker-alt",
          to: paths.locationRestrictions,
          active: true,
          privileges: [PRIV.MANAGE_APIS, PRIV.MANAGE_LOCATION_RESTRICTIONS],
        },
      ],
    },

    // system settings
    {
      name: "System Settings",
      icon: "cog",
      active: true,
      children: [
        {
          name: "Health Checks",
          icon: "briefcase-medical",
          to: paths.healthChecks,
          active: true,
          privilege: PRIV.MANAGE_HEALTH_CHECKS,
        },
        {
          name: "Feature Dials",
          // icon: "tachometer-alt",
          icon: "sliders-h",
          to: paths.featureDial,
          active: true,
          privilege: PRIV.VIEW_FEATURE_DIAL,
        },
        {
          name: "User Agreements",
          icon: "handshake",
          active: true,
          privilege: PRIV.VIEW_AGREEMENTS,
          children: [
            {
              name: "Active Agreement",
              to: paths.activeAgreement,
              active: false,
              privilege: PRIV.VIEW_ACTIVE_AGREEMENT,
            },

            {
              name: "Agreements",
              to: paths.agreements,
              active: true,
              privilege: PRIV.VIEW_AGREEMENTS,
            },
          ],
        },
        {
          name: "Security Questions",
          icon: "question-circle",
          to: paths.securityQuestions,
          active: true,
          privilege: PRIV.VIEW_SECURITY_QUESTIONS,
        },
        {
          name: "App Config",
          icon: "sliders-h",
          to: paths.appConfig,
          active: true,
        },
      ],
    },
  ],
};

export default [allRoutes];
